import { CSSProperties, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import { A } from './A'
import { Button } from './Button'
import { Flex } from './Flex'
import { Headline2, Label } from './Typography'

import { colors } from '@/constants'

const Wrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 1.25rem;
`

const IconWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  padding: 1.125rem;
  border-radius: 1.25rem;
  background-color: ${colors.darkBlue2};
`

const InnerWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  text-align: center;
`

export function Message({
  icon,
  title,
  description,
  redirect,
  wrapperStyles,
  children,
  buttonStyles = { width: '10.625rem' },
}: {
  icon?: JSX.Element
  title: string
  description: string
  redirect?: string
  wrapperStyles?: CSSProperties
  buttonStyles?: CSSProperties
} & PropsWithChildren) {
  return (
    <Wrapper>
      <InnerWrapper style={wrapperStyles}>
        {icon ? <IconWrapper>{icon}</IconWrapper> : null}
        <Headline2>{title}</Headline2>
        <Label style={{ fontWeight: '600' }} color="light2">
          {description}
        </Label>
      </InnerWrapper>
      {redirect && (
        <A href={redirect}>
          <Button style={buttonStyles}>{children}</Button>
        </A>
      )}
    </Wrapper>
  )
}
